import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=457069f1&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=457069f1&lang=less&scoped=scoped"
import style1 from "./noticeList.vue?vue&type=style&index=1&id=457069f1&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457069f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457069f1')) {
      api.createRecord('457069f1', component.options)
    } else {
      api.reload('457069f1', component.options)
    }
    module.hot.accept("./noticeList.vue?vue&type=template&id=457069f1&scoped=true", function () {
      api.rerender('457069f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/arrivalNotice/noticeList.vue"
export default component.exports